import moment from 'moment-timezone';
import { time_day_format } from '../../../../constants';

// Display helpers for the Hidden Teachers page, kept out of the component so they can be tested.

// A teacher hidden before PROD-9278 has no audit row, by decision (no backfill). Their reason is
// genuinely unknown, and saying so beats a blank cell that reads like a missing value.
export const UNKNOWN = 'Not recorded';

// Must equal goserver's models.TeacherHideSourceSystem. The two are joined only by this string,
// so if that constant is ever renamed every automatic hide silently loses its actor — which is
// what the test on this file is really guarding.
export const SYSTEM_SOURCE = 'SYSTEM';

/**
 * Formats a hide timestamp in the CMS user's timezone, never the browser's (rules/hridaya.md).
 * The trial-points page sits next to this one in the nav; formatting on the viewer's OS zone
 * would have the two disagree about when the same hide happened.
 *
 * @param {string} value RFC3339 UTC from the API, or empty when there is no audit row
 * @param {string} iana_timezone the CMS user's zone from state.home.iana_timezone
 */
export const format_date = (value, iana_timezone) => {
  if (!value) return UNKNOWN;
  const m = iana_timezone ? moment(value).tz(iana_timezone) : moment(value);
  if (!m.isValid()) return value;
  return m.format(time_day_format);
};

/**
 * Who hid the teacher. A SYSTEM hide has no actor because nobody performed it, so naming the
 * system is the honest answer rather than falling through to "not recorded".
 */
export const format_actor = (row) => {
  if (!row) return UNKNOWN;
  if (row.source === SYSTEM_SOURCE) return 'System';
  return row.hidden_by || UNKNOWN;
};
